import * as Data$dArray$dST from "../Data.Array.ST/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
const swap = x => y => array => {
  const st = [...array];
  const a = Data$dArray$dST.peekImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, x, st);
  const b = Data$dArray$dST.peekImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, y, st);
  if (a.tag === "Just" && b.tag === "Just") {
    Data$dArray$dST.pokeImpl(x, b._1, st);
    Data$dArray$dST.pokeImpl(y, a._1, st);
  }
  return st;
};
const shiftInsert = v => v1 => v2 => {
  if (v === v1) { return v2; }
  const st = [...v2];
  const item = Data$dArray$dST.splice(v)(1)([])(st)();
  Data$dArray$dST.splice(v1)(0)(item)(st)();
  return st;
};
export {shiftInsert, swap};
